// React
import React, { memo } from 'react'
import PropTypes from 'prop-types'

// Components
import BLocationPicker from 'ui/blocks/Picker/Location'
import Div from 'ui/elements/Div'
import Skeleton from 'ui/blocks/Skeleton'

// Libraries
import { components } from 'react-select'
import { isEmpty } from 'lodash'

const LocationPickerOptionComponent = (props) => {
  const location = props.selectProps.locations.toList().find((selectLocation) => {
    return selectLocation.id === props.data?.value
  })

  const deliveryDistance = props.selectProps.deliveryDistances?.find((record) => {
    return record.locationId === location.id
  })

  return (
    <components.Option {...props}>
      <BLocationPicker.Option>
        <Div>
          <BLocationPicker.Title isOption>{location?.name}</BLocationPicker.Title>
          {location?.main_address?.value && (
            <BLocationPicker.Subtitle isOption>{location.main_address.value}</BLocationPicker.Subtitle>
          )}
        </Div>
        {props.selectProps.showDeliveryDistances && isEmpty(deliveryDistance) && <Skeleton width={50} />}
        {props.selectProps.showDeliveryDistances && !isEmpty(deliveryDistance) &&
          <Div>{deliveryDistance.distance} {deliveryDistance.distance_unit}</Div>}
      </BLocationPicker.Option>
    </components.Option>
  )
}

LocationPickerOptionComponent.propTypes = {
  selectProps: PropTypes.shape({
    locations: PropTypes.object,
    deliveryDistances: PropTypes.any,
    showDeliveryDistances: PropTypes.bool
  }),
  data: PropTypes.shape({
    value: PropTypes.string
  })
}

export const LocationPickerOption = memo(LocationPickerOptionComponent)

LocationPickerOption.displayName = 'LocationPicker'
